module.exports = __webpack_public_path__ + "img/电梯动画2.79005fd9.png";